export const FILES_MAX_SIZE = 10; // size in mb